import moment from 'jalali-moment';
import storage from '@/utils/storage';
import http, { getFaceEnrollmentUrl, getUniversityUrl } from './http';

export const enroll = async (userId: any, image: Blob) => {
  const form = new FormData();
  const file = new File([image], 'image.png', { lastModified: moment().unix() });
  const baseURL = getFaceEnrollmentUrl();
  const universityURL = getUniversityUrl();
  const token = storage.get('TOKEN') as string;

  form.append('token', token);
  form.append('user_id', userId);
  form.append('input_image', file);
  form.append('base_url', universityURL);

  return http.request({
    baseURL,
    data: form,
    method: 'POST',
    url: '/face/enroll',
    timeout: 5400000, // 90s
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const enrollVideo = async (userId: any, video: File) => {
  const form = new FormData();
  const token = storage.get('TOKEN') as string;
  const universityURL = getUniversityUrl();
  const baseURL = getFaceEnrollmentUrl();

  form.append('token', token);
  form.append('user_id', userId);
  form.append('input_image', video);
  form.append('base_url', universityURL);

  return http.request({
    baseURL,
    data: form,
    method: 'POST',
    url: '/face/enroll',
    timeout: 5400000, // 90s
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
